import { ChartPieDataset, ChartBarDataset } from "pptxgenjs"
import {
	Allocation ,
	allocationLabels,
	accountIsLumpSumAllocation,
	accountIsEqualizationAllocation,
	accountIsParticipation,
	accountIsAttributionOfCompensation,
	accountIsOtherAllocation
} from "../../../../../domain/sfp/allocation-domain"
import * as DemographyDomain from "../../../../../domain/sfp/demography-domain"
import { Demography, Observation } from "../../../../../model"

export function createGlobalChartData(
	name: string,
	observations: Observation[],
	year: number
): [ChartPieDataset] {
	const labels: string[] = [
		allocationLabels[Allocation.LumpSum],
		allocationLabels[Allocation.Equalization],
		allocationLabels[Allocation.Participation],
		allocationLabels[Allocation.OfCompensation],
		allocationLabels[Allocation.Other]
	]
	const values: number[] = labels.map(() => 0)
	const dataset: ChartPieDataset = observations.reduce<ChartPieDataset>(
		(dataset, o) => {
			if (year === o.year) {
				switch (true) {
					case accountIsLumpSumAllocation(o.account):
						values[0] += o.amount
						break
					case accountIsEqualizationAllocation(o.account):
						values[1] += o.amount
						break
					case accountIsParticipation(o.account):
						values[2] += o.amount
						break
					case accountIsAttributionOfCompensation(o.account):
						values[3] += o.amount
						break
					case accountIsOtherAllocation(o.account):
						values[4] += o.amount
						break
				}
			}
			return dataset
		}, { labels, name, values }
	)

	return [dataset]
}

export function createInhabitantsChartData(
	allocationsChartData: ChartBarDataset[],
	demographies: Demography[]
): ChartBarDataset[] {
	return allocationsChartData.map<ChartBarDataset>(dataset => {
		// copie du dataset
		const inhabitantsDataset: ChartBarDataset = {
			labels: dataset.labels.slice(),
			name: dataset.name,
			values: dataset.values.slice()
		}

		inhabitantsDataset.labels.forEach((label, labelIndex) => {
			const year = parseInt(label)
			const demography = DemographyDomain.findByYear(demographies, year)
			inhabitantsDataset.values[labelIndex] = demography && demography.population
				? dataset.values[labelIndex] / demography.population : 0
		})

		return inhabitantsDataset
	})
}


// WEBPACK FOOTER //
// ./src/component/management-report/generator/observation-generator/allocation-generator/utils.ts